import Pusher from 'pusher-js';
window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.Popper = require('@popperjs/core').default;
window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('./multiselect.min');
require('./custom');
require('./publication');

window.Pusher = Pusher;
Pusher.logToConsole = true;
const pusher = new Pusher("taifapay",{
    wsHost: "ctrl.taifamobile.co.ke",
    wsPath:"/websocket",
    wsPort:  80,
    wssPort:  443,
    forceTLS: true,
    enabledTransports: ["ws", "wss"]
});
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

